import InventoryPromoLink from './InventoryPromoLink';
import InventoryPromoLinkTall from './InventoryPromoLinkTall';


export default InventoryPromoLink;
export {
    InventoryPromoLinkTall
};
